import { settingsCopy } from '@/copy'
import { Alert } from '@/ui/Alert/Alert'
import { Button } from '@/ui/Button/Button'
import { Inline } from '@/ui/layout/Inline'
import { Text } from '@/ui/layout/Text'

/**
 * A failed background refetch: the loaded rows stay; this sits above them
 * (S7's pattern). The Retry sits inside the Alert (D73, D188); the caller's
 * stack owns the gap below.
 */
export function RefreshFailed({
  message,
  onRetry,
}: {
  message: string
  onRetry: () => void
}) {
  return (
    <Alert tone="warning">
      <Inline gap="space-8" align="baseline" wrap>
        <Text>{message}</Text>
        <Button variant="outline" size="sm" onClick={onRetry}>
          {settingsCopy.retry}
        </Button>
      </Inline>
    </Alert>
  )
}
